export const courseTypes = {
  ePub: "ePub",
  bronteViewer: "Bronte Viewer",
};

export const pluginList = {
  "Bronte Viewer eText Plugin": courseTypes.bronteViewer,
  "Pearson eText course plugin": courseTypes.ePub,
};